import { useQuery } from "@tanstack/react-query";
import { useAccount } from "wagmi";
import { fetchUserRedemptions, type UserRedemptionsData } from "@/services";
import { QUERY_KEYS, QUERY_CONFIG } from "@/config";

export interface RedemptionsStore {
    redemptionsData: UserRedemptionsData | null;
    isLoading: boolean;
    error: Error | null;
}

export const useRedemptionsStore = (): RedemptionsStore => {
    const { address } = useAccount();

    const {
        data: redemptionsData,
        isLoading,
        error,
    } = useQuery<UserRedemptionsData>({
        queryKey: QUERY_KEYS.REDEMPTIONS.USER(address ?? ""),
        queryFn: () => fetchUserRedemptions(address!),
        enabled: !!address,
        ...QUERY_CONFIG.REDEMPTIONS,
    });

    return {
        redemptionsData: redemptionsData || null,
        isLoading,
        error: error as Error | null,
    };
};
